var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComment = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 16,
  viewBox: "0 0 15 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#8C8C8C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M234.503 222c-2.899-.001-5.539 1.68-6.78 4.32l-.109.242c-1.04 2.426-.743 5.22.768 7.365l.112.154-.025.087c-.263.871-.57 1.508-.764 1.663-.215.123-.417.402-.492.727-.074.325-.014.667.167.946l.053.07c.266.307.664.463 1.065.419l.153-.005c.84-.058 2.14-.589 3.451-1.272l.216.07c2.684.822 5.62.067 7.585-1.99 2.086-2.182 2.676-5.41 1.498-8.198-1.145-2.712-3.746-4.498-6.655-4.594l-.243-.004zm0 1.263c2.507.001 4.77 1.51 5.75 3.832.98 2.32.49 5.006-1.247 6.823-1.738 1.82-4.388 2.417-6.731 1.52l-.264-.102-.249.134-.212.112c-1.068.556-2.197 1.027-2.874 1.13l-.107.014.05-.05c.471-.507.859-1.414 1.165-2.567l.084-.314-.204-.251c-1.531-1.882-1.848-4.483-.815-6.68 1.001-2.129 3.095-3.51 5.42-3.597l.234-.004z",
  transform: "translate(-227 -222) matrix(-1 0 0 1 469 0)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export default ForwardRef;